import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { MessageBox, Message, Notification } from 'element-ui'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 50000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = getToken()
  }
  const publishApiPaths = [
    '/api/sysUser/getLangList',
    '/api/upload/ossToken',
    '/api/upload/getSignUrl',
    '/api/i18nCreation/creationList',
    '/api/i18nTag/tagList',
    '/api/i18nCreation/creationDetail'
  ]
  const isPublishRoute = router.currentRoute.path.startsWith('/publish')
  const isPublishApi = publishApiPaths.some(p => config.url.includes(p))
  config.headers['Accept-Language'] = config.headers['Accept-Language'] ||
    (isPublishRoute && isPublishApi ? 'zh-CN' : store.state.language || 'en-US')
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    if (code === 401) {
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('logout').then(() => {
          location.href = '/home';
        })
      })
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    // if (message == "Network Error") {
    //   message = "后端接口连接异常";
    // }
    // else if (message.includes("timeout")) {
    //   message = "系统接口请求超时";
    // }
    // else if (message.includes("Request failed with status code")) {
    //   message = "系统接口" + message.substr(message.length - 3) + "异常";
    // }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
